import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from 'src/app/service/config.service';
import { TokenService } from 'src/app/shared/services/customer-api/token.service';
import { RoutingService } from 'src/app/service/routing.service';
import { ApiBaseService } from '../api-base.service';

@Injectable({
  providedIn: 'root',
})
export class DataApiService extends ApiBaseService {
  private dataApiUrl: string;

  constructor(
    http: HttpClient,
    config: ConfigService,
    routing: RoutingService,
    tokenService: TokenService,
  ) {
    super(http, config, routing, tokenService);
    this.dataApiUrl = this.config.appConfig.urlDataApi;
  }

  protected getRequestUrl(endpoint: string, version?: string): string {
    if (endpoint.startsWith('/')) {
      return `${this.dataApiUrl}${endpoint}`;
    }
    if (version) {
      return `${this.dataApiUrl}/${version}/api/${endpoint}`;
    }
    return `${this.dataApiUrl}/api/${endpoint}`;
  }
}
